import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "m-0" }
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "p-3" }
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = { class: "p-3" }
const _hoisted_7 = {
  key: 2,
  class: "card col-12 col-lg-8"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_12 = { class: "detailsRow d-flex" }
const _hoisted_13 = { class: "detailsCol" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_LuSpinner = _resolveComponent("LuSpinner")!
  const _component_DetailsRow = _resolveComponent("DetailsRow")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.offer !== null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Modal, {
            ref: "accepted-modal",
            onClose: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push({ name: 'StudentHome' })))
          }, {
            header: _withCtx(() => [
              _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("offerresponse.popup-accepted.title", {
              name: _ctx.offer.noteTaker.firstName,
            })), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("offerresponse.popup-accepted.message")), 1)
            ]),
            _: 1
          }, 512),
          _createVNode(_component_Modal, {
            ref: "declined-modal",
            onClose: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push({ name: 'StudentHome' })))
          }, {
            header: _withCtx(() => [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("offerresponse.popup-declined.title")), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("offerresponse.popup-declined.message")), 1)
            ]),
            _: 1
          }, 512),
          _createVNode(_component_Modal, { ref: "error-modal" }, {
            header: _withCtx(() => [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("shared.popup-error.title", {
              name: _ctx.offer.noteTaker.firstName,
            })), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("shared.popup-error.message")), 1)
            ]),
            _: 1
          }, 512)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LuSpinner, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.offer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("course-occurrence.offer.offer-response-title")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("course-occurrence.offer.offer-response-description")), 1),
          (_ctx.offer)
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_8, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.$t("course-occurrence.offer.offer-information-title")), 1),
                _createVNode(_component_DetailsRow, { caption: "shared.courseCode" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.offer.courseOccurrence.courseCode), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_DetailsRow, { caption: "course-occurrence.title" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$root.$i18n.locale === "sv"
          ? _ctx.offer.courseOccurrence.titleSv
          : _ctx.offer.courseOccurrence.titleEn), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_DetailsRow, { caption: "course-occurrence.courseStartDate" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.offer.courseOccurrence.courseStartDate), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_9, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("course-occurrence.offer.policy-required-description")) + " ", 1),
              _createElementVNode("a", {
                id: "termsLink",
                href: _ctx.termsAndConditionsUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.haveClickedLink = true))
              }, _toDisplayString(_ctx.$t("course-occurrence.offer.terms-and-conditions")), 9, _hoisted_10),
              _hoisted_11
            ]),
            _createVNode(_component_CheckboxInput, {
              fieldId: "accept",
              label: _ctx.$t('shared.accept-policy-full'),
              checked: _ctx.termsAccepted,
              disabled: !_ctx.haveClickedLink,
              onUpdate: _cache[3] || (_cache[3] = (checked) => (_ctx.termsAccepted = checked))
            }, null, 8, ["label", "checked", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                "background-color": "btn btn-primary",
                id: "acceptBtn",
                type: "button",
                class: "btn btn-primary mr-2",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.acceptOffer())),
                disabled: !_ctx.termsAccepted || _ctx.isLoading
              }, _toDisplayString(_ctx.$t("shared.accept")), 9, _hoisted_14)
            ]),
            _createElementVNode("button", {
              id: "declineBtn",
              type: "button",
              class: "btn btn-outline-primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.declineOffer())),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t("shared.decline")), 9, _hoisted_15)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}